// FPEL 2023 — the inaugural season. Pure data: anything here must survive
// JSON.stringify, so a future Supabase `league_configs` row can hold the same
// object (see src/seasons/index.js for the loader seam).
const season2023 = {
  season: 2023,
  leagueId: 175750856,
  label: 'Season 1',
  results: {
    champion: {
      team: 'VanceInYourPants',
      manager: 'Luke Vance',
      note: '280.78 in the two-week finals',
    },
    runnerUp: 'No MoJoe',
    firstOut: { team: 'Joe Buck Yourself', week: 6 },
  },
};

export default season2023;
